import { Button, Space } from 'antd'
import CIMSButton from 'components/CIMSButton'
import CIMSDrawer from 'components/CIMSDrawer'
import type { DisabledOptions } from 'hooks/useDisabledOptions'
import { useState } from 'react'
import type { ConfiguredFieldsFormState } from '../../hooks/useConfiguredFields/types'
import ApprovalActionForm from './components/ApprovalActionForm'
import type { ApprovalActionDrawerProps } from './types'

/** Presents the approval form with guarded submission and cancellation controls. */
function ApprovalActionDrawer({
  onCancel,
  onSubmit,
  open,
  pending,
  session,
}: ApprovalActionDrawerProps) {
  const action = session.target.action
  const [formState, setFormState] = useState<ConfiguredFieldsFormState>({
    loading: action.fields.some(({ type }) => type === 'pay_items'),
    valid: false,
  })
  const formId = `workflow-record-approval-action-${session.target.recordId}-${session.target.optionId}-${action.action}`
  let submitDisabledOptions: DisabledOptions | undefined
  if (!pending && formState.loading) {
    submitDisabledOptions = { disabled: true, reason: 'loading' }
  } else if (!pending && !formState.valid) {
    submitDisabledOptions = {
      disabled: true,
      reason: {
        why: 'disabled',
        message:
          'Complete required fields and fix any errors before submitting',
      },
    }
  }
  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Space>
        <Button disabled={pending} onClick={onCancel}>
          Cancel
        </Button>
        <CIMSButton
          disabled={submitDisabledOptions}
          form={formId}
          htmlType="submit"
          loading={pending}
          type="primary"
        >
          {action.actionLabel}
        </CIMSButton>
      </Space>
    </div>
  )

  return (
    <CIMSDrawer
      footer={footer}
      onClose={onCancel}
      open={open}
      title={action.dialogLabel}
    >
      <ApprovalActionForm
        formId={formId}
        onStateChange={setFormState}
        onSubmit={onSubmit}
        pending={pending}
        session={session}
      />
    </CIMSDrawer>
  )
}

export default ApprovalActionDrawer
